




















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

@Component
export default class PlayerFooter extends Vue {
  private isBtnDisabled = true
  private isPlaying = false
  private audio: HTMLAudioElement | null = null

  private voiceData: VoiceData | null = null
  private volume = 0.5

  public playVoice(voiceData: VoiceData) {
    this.isBtnDisabled = false
    this.voiceData = voiceData
    this.audio = new Audio(voiceData.voiceUrl)
    this.audio.volume = this.volume
    this.audio.addEventListener('ended', () => {
      this.isPlaying = false
    })
    this.isPlaying = true
    this.audio.play().then()
  }

  private stopVoice() {
    if (this.audio) {
      this.audio.pause()
      this.audio.currentTime = 0
      this.isPlaying = false
    }
  }
}
